import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useState, useRef, useCallback } from 'react';
import { Menu } from '../../components/Menu';
// Inline SVG icons for each tool — 16×16 viewBox, stroke-based
const BoxIcon = () => (_jsx("svg", { width: "16", height: "16", viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: _jsx("rect", { x: "2", y: "2", width: "12", height: "12", rx: "1", stroke: "currentColor", strokeWidth: "1.5" }) }));
const CircleIcon = () => (_jsx("svg", { width: "16", height: "16", viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: _jsx("circle", { cx: "8", cy: "8", r: "6", stroke: "currentColor", strokeWidth: "1.5" }) }));
const LineIcon = () => (_jsx("svg", { width: "16", height: "16", viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: _jsx("line", { x1: "2", y1: "14", x2: "14", y2: "2", stroke: "currentColor", strokeWidth: "1.5", strokeLinecap: "round" }) }));
const ArrowIcon = () => (_jsxs("svg", { width: "16", height: "16", viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: [_jsx("line", { x1: "2", y1: "14", x2: "13", y2: "3", stroke: "currentColor", strokeWidth: "1.5", strokeLinecap: "round" }), _jsx("polyline", { points: "7,2.5 13.5,2.5 13.5,9", stroke: "currentColor", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round", fill: "none" })] }));
const FreeformIcon = () => (_jsx("svg", { width: "16", height: "16", viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: _jsx("path", { d: "M2 12C4 6 6 10 8 6C10 2 12 8 14 4", stroke: "currentColor", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }) }));
const TextIcon = () => (_jsxs("svg", { width: "16", height: "16", viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: [_jsx("line", { x1: "3", y1: "3", x2: "13", y2: "3", stroke: "currentColor", strokeWidth: "1.5", strokeLinecap: "round" }), _jsx("line", { x1: "8", y1: "3", x2: "8", y2: "13", stroke: "currentColor", strokeWidth: "1.5", strokeLinecap: "round" }), _jsx("line", { x1: "5", y1: "13", x2: "11", y2: "13", stroke: "currentColor", strokeWidth: "1.5", strokeLinecap: "round" })] }));
const EraserIcon = () => (_jsxs("svg", { width: "16", height: "16", viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: [_jsx("path", { d: "M9.5 2.5L14 7L8 13H4L2 11L9.5 2.5Z", stroke: "currentColor", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }), _jsx("line", { x1: "6", y1: "6.5", x2: "10.5", y2: "11", stroke: "currentColor", strokeWidth: "1.5", strokeLinecap: "round" })] }));
const TOOL_ICONS = {
    box: BoxIcon,
    circle: CircleIcon,
    line: LineIcon,
    arrow: ArrowIcon,
    freeform: FreeformIcon,
    text: TextIcon,
    eraser: EraserIcon,
};
const TOOLS = [
    { value: 'box', label: 'Box', shortcut: 'B' },
    { value: 'circle', label: 'Circle', shortcut: 'O' },
    { value: 'line', label: 'Line', shortcut: 'L' },
    { value: 'arrow', label: 'Arrow', shortcut: 'A' },
    { value: 'freeform', label: 'Freeform', shortcut: 'F' },
    { value: 'text', label: 'Text', shortcut: 'T' },
    { value: 'eraser', label: 'Eraser', shortcut: 'E' },
];
const TOOL_LABELS = {
    box: 'Box',
    circle: 'Circle',
    line: 'Line',
    arrow: 'Arrow',
    freeform: 'Freeform',
    text: 'Text',
    eraser: 'Eraser',
};
const ToolIcon = ({ tool }) => {
    const Icon = TOOL_ICONS[tool];
    return _jsx(Icon, {});
};
export const ToolDropdown = React.memo(function ToolDropdown({ activeTool, onToolChange, }) {
    const [isOpen, setIsOpen] = useState(false);
    const triggerRef = useRef(null);
    const close = useCallback(() => {
        setIsOpen(false);
    }, []);
    const handleToggle = useCallback(() => {
        setIsOpen((prev) => !prev);
    }, []);
    const items = TOOLS.map((tool) => ({
        type: 'radio',
        id: tool.value,
        label: tool.label,
        icon: _jsx(ToolIcon, { tool: tool.value }),
        checked: tool.value === activeTool,
        onClick: () => {
            onToolChange(tool.value);
            setIsOpen(false);
        },
    }));
    const ActiveIcon = TOOL_ICONS[activeTool];
    return (_jsxs("div", { className: "hekate-annotation-tool-dropdown", children: [_jsxs("button", { ref: triggerRef, className: "hekate-annotation-toolbar-btn hekate-annotation-tool-trigger", onClick: handleToggle, "aria-haspopup": "true", "aria-expanded": isOpen, "aria-label": `Tool: ${TOOL_LABELS[activeTool]}`, "data-tooltip": "Drawing Tool", type: "button", children: [_jsx("span", { className: "hekate-annotation-tool-trigger-icon", children: _jsx(ActiveIcon, {}) }), _jsx("span", { className: "hekate-annotation-tool-trigger-label", children: TOOL_LABELS[activeTool] }), _jsx("span", { className: "hekate-annotation-tool-trigger-arrow", "aria-hidden": "true" })] }), _jsx(Menu, { items: items, isOpen: isOpen, onClose: close, ariaLabel: "Drawing tools", triggerRef: triggerRef, className: "hekate-annotation-tool-menu" })] }));
});
